export const FICHES = {
  "BAR-TH-137": {
    reference: "BAR-TH-137",
    version: "vA79-4",
    label: "Raccordement d'un bâtiment résidentiel collectif à un réseau de chaleur",
    shortLabel: "Raccordement collectif à un réseau de chaleur",
    dureeVie: 30,
    designation:
      "Raccordement d'un bâtiment résidentiel existant à un réseau de chaleur, réalisé conformément à la fiche d'opération standardisée des certificats d'économies d'énergie (CEE) BAR-TH-137 « Raccordement d'un bâtiment résidentiel à un réseau de chaleur », version en vigueur.",
  },
  "BAR-TH-179": {
    reference: "BAR-TH-179",
    version: "vA81-2",
    label: "Pompe à chaleur collective de type air/eau",
    shortLabel: "PAC air/eau collective",
    dureeVie: 22,
    puissanceMax: 400,
    designation:
      "Mise en place d'une ou de plusieurs pompe(s) à chaleur de type air/eau de puissance thermique nominale inférieure ou égale à 400 kW pour un système de chauffage collectif, réalisée conformément à la fiche d'opération standardisée des certificats d'économies d'énergie (CEE) BAR-TH-179 « Pompe à chaleur collective de type air/eau », version en vigueur.",
  },
  "BAR-TH-127": {
    reference: "BAR-TH-127",
    version: "vA58-6",
    label: "Ventilation mécanique simple flux hygroréglable collective",
    shortLabel: "VMC hygroréglable collective",
    dureeVie: 17,
    designation:
      "Mise en place d'une ventilation mécanique contrôlée simple flux hygroréglable (France métropolitaine), réalisée conformément à la fiche d'opération standardisée des certificats d'économies d'énergie (CEE) BAR-TH-127 « Ventilation mécanique simple flux hygroréglable », version en vigueur.",
  },
};

export const ZONES = ["H1", "H2", "H3"];
export const CLIENTS = ["RIVP", "ELOGIE SIEMP"];
export const OBLIGES = ["BOLLORE", "TPNO", "YNERGIE"];

const ZONE_DEPTS = {
  H1: "01 02 03 05 08 10 14 15 19 21 23 25 27 28 38 39 42 43 45 51 52 54 55 57 58 59 60 61 62 63 67 68 69 70 71 73 74 75 76 77 78 80 87 88 89 90 91 92 93 94 95",
  H2: "04 07 09 12 16 17 18 22 24 26 29 31 32 33 35 36 37 40 41 44 46 47 48 49 50 53 56 64 65 72 79 81 82 84 85 86",
  H3: "06 11 13 2A 2B 30 34 66 83",
};

/* Zone climatique CEE (France métropolitaine) à partir du code postal */
export function zoneFromPostcode(cp) {
  const code = String(cp || "").trim();
  if (!/^\d{5}$/.test(code)) return null;
  let dept = code.slice(0, 2);
  if (dept === "20") dept = parseInt(code, 10) < 20200 ? "2A" : "2B";
  const zone = Object.keys(ZONE_DEPTS).find((z) => ZONE_DEPTS[z].split(" ").includes(dept));
  return zone ? { zone, dept } : null;
}
export const LABELS = {
  usage: { chauffage: "Chauffage", chauffage_ecs: "Chauffage et ECS" },
  application: { moyenne_haute: "Moyenne / haute température", basse: "Basse température" },
  typeSysteme: { A: "Type A (bouches hygro)", B: "Type B (bouches + entrées d'air hygro)" },
  caisson: { basse_conso: "Basse consommation", standard: "Standard", basse_pression: "Basse pression" },
};

const T137 = { H1: 47700, H2: 39500, H3: 30800 };
const T179 = {
  chauffage: { H1: [100000, 107000, 112000, 115000, 117000], H2: [84000, 89000, 93000, 96000, 97000], H3: [60000, 64000, 67000, 69000, 70000] },
  chauffage_ecs: { H1: [146000, 155000, 163000, 167000, 170000], H2: [127000, 135000, 142000, 146000, 148000], H3: [100000, 107000, 112000, 115000, 117000] },
};
const ETAS_SEUILS = [111, 126, 150, 175, 190];
const T127 = { H1: 21800, H2: 17800, H3: 11900 };
const R127 = { A: { basse_conso: 0.96, standard: 0.91, basse_pression: 0.76 }, B: { basse_conso: 1, standard: 0.95, basse_pression: 0.78 } };

export const DOC_TYPES = ["Devis à envoyer", "Devis signé", "Facture", "Attestation sur l'honneur", "Étude de dimensionnement", "Contrat de fourniture de chaleur", "Autre"];
export const REQUIRED_DOC_TYPES = ["Devis à envoyer", "Devis signé", "Facture", "Attestation sur l'honneur"];
export const STATUTS = ["En création", "Devis envoyé", "Devis validé", "En instruction", "Validé", "Réglé", "Mise en conformité"];

export const STATUT_INFOS = {
  "En création": "Dossier créé dans le portail ; chiffrage et constitution du dossier en cours.",
  "Devis envoyé": "Devis transmis au client : la pièce « Devis à envoyer » a été validée.",
  "Devis validé": "Devis signé reçu et validé ; les travaux sont en cours ou programmés.",
  "En instruction": "Facture et attestation sur l'honneur reçues : le dossier est en cours de contrôle.",
  "Validé": "Tous les documents obligatoires sont validés ; l'appel à facturation est en cours.",
  "Réglé": "La prime CEE et la commission sont réglées.",
  "Mise en conformité": "Un document a été refusé : le dossier doit être remis en conformité et la pièce corrigée redéposée sur le portail.",
};

export const VERSEMENT_PRIME_LABELS = { remise_sur_devis: "Remise sur devis" };

export const DEFAULT_PRICING = {
  prixAutre: 7.5, paliers: [], prixClientMin: 6.5, prixClientMax: 7.5,
  prixPrecariteReel: 7.5, prixPrecariteMin: 6.5, prixPrecariteMax: 7.5, colonnePrecarite: "A",
};
export const clientRange = (pricing = DEFAULT_PRICING) => ({
  min: parseFloat(pricing.prixClientMin ?? DEFAULT_PRICING.prixClientMin),
  max: parseFloat(pricing.prixClientMax ?? DEFAULT_PRICING.prixClientMax),
});
export const precariteRange = (pricing = DEFAULT_PRICING) => ({
  min: parseFloat(pricing.prixPrecariteMin ?? DEFAULT_PRICING.prixPrecariteMin),
  max: parseFloat(pricing.prixPrecariteMax ?? DEFAULT_PRICING.prixPrecariteMax),
});
/* Jauge commission : % (0-100) de la marge disponible (max - min) pris en commission */
export const pctNum = (p) => { const n = parseFloat(p); return Number.isFinite(n) ? n : 100; };
const clampPct = (p) => Math.min(100, Math.max(0, pctNum(p)));
export const pctToPrice = (pct, { min, max }) => max - (clampPct(pct) / 100) * (max - min);
export const priceToPct = (price, { min, max }) =>
  price == null || max <= min ? 100 : clampPct(Math.round(((max - parseFloat(price)) / (max - min)) * 100));

/* Arrêté du 29/12/2014 modifié, annexe I : part du volume au bénéfice des ménages précaires (A grande précarité, B précarité) */
const PCT = "01 55 88|02 63 91|03 67 93|04 67 92|05 53 88|06 43 80|07 67 94|08 64 93|09 74 95|10 63 92|11 74 95|12 67 94|13 61 89|14 60 91|15 65 93|16 70 93|17 65 93|18 61 91|19 68 93|21 58 90|22 71 95|23 65 92|24 67 93|25 64 91|26 70 94|27 59 90|28 57 87|29 69 95|2A 59 87|2B 63 89|30 77 95|31 63 90|32 64 91|33 55 88|34 68 93|35 61 92|36 61 92|37 67 93|38 60 90|39 64 91|40 64 92|41 61 92|42 63 92|43 68 93|44 62 91|45 61 91|46 70 94|47 72 94|48 59 89|49 56 87|50 59 90|51 51 85|52 60 90|53 60 92|54 60 89|55 67 92|56 66 94|57 61 89|58 63 92|59 63 92|60 55 87|61 63 92|62 66 93|63 59 90|64 60 90|65 66 93|66 72 94|67 61 89|68 61 90|69 58 89|70 66 93|71 61 91|72 61 92|73 53 87|74 52 85|75 51 80|76 54 87|77 62 92|78 53 87|79 62 93|80 64 91|81 74 96|82 77 96|83 62 90|84 70 94|85 63 94|86 65 92|87 63 92|88 62 91|89 68 93|90 64 90|91 55 89|92 46 82|93 62 90|94 53 86|95 58 89|OM 80 94";
export const PRECARITE = Object.fromEntries(PCT.split("|").map((r) => { const [d, a, b] = r.split(" "); return [d, { A: +a, B: +b }]; }));
export function precaritePct(dept, colonne = "A") {
  let d = String(dept || "").trim().toUpperCase();
  if (d.startsWith("97")) d = "OM";
  if (/^\d$/.test(d)) d = `0${d}`;
  return PRECARITE[d] ? PRECARITE[d][colonne] / 100 : null;
}
export const ENERGIES_REMPLACEES = { gaz: "Chaudière gaz", fioul: "Chaudière fioul" };
const cdpEnergieIssue = (op) => (ENERGIES_REMPLACEES[op.energieRemplacee] ? [] : ["Coup de pouce : préciser l'énergie de la chaudière remplacée (gaz ou fioul)"]);

const n = (v) => parseFloat(v) || 0;

/* Volume kWh cumac d'une opération (résidentiel collectif) selon la formule officielle de sa fiche */
export const pacList = (op) =>
  Array.isArray(op.pacs) && op.pacs.length
    ? op.pacs.map((p) => parseFloat(p) || 0)
    : Array(Math.max(1, parseInt(op.nbPac, 10) || 1)).fill(parseFloat(op.puissancePac) || 0);
export const ratioR = (pac, chauf) => (pac > 0 && chauf > 0 && pac / chauf < 0.4 ? pac / chauf : 1);
export function volumeKwh(op) {
  const zone = op.zone || "H1";
  const issues = [];
  if (!FICHES[op.fiche]) return { kwh: n(op.kwhCumac), logements: n(op.nbLogements), detail: "", issues };
  if (op.fiche === "BAR-TH-137") {
    const nb = n(op.nbLogements);
    if (nb <= 0) issues.push("le nombre d'appartements raccordés doit être renseigné");
    if (op.cdp) issues.push(...cdpEnergieIssue(op));
    if (op.cdp && nb > 0) {
      const big = nb > 125;
      const kwh = big ? 54000 * nb + 5200000 : 24000 * nb + 9000000;
      return { kwh, logements: nb, detail: `Coup de pouce : ${big ? "54 000" : "24 000"} × ${nb} + ${big ? "5 200 000" : "9 000 000"}`, issues };
    }
    return { kwh: T137[zone] * nb, logements: nb, detail: `${T137[zone].toLocaleString("fr-FR")} × ${nb} appartement(s)`, issues };
  }
  if (op.fiche === "BAR-TH-179") {
    const nb = n(op.nbLogements);
    const etas = n(op.etas);
    const usage = op.usage || "chauffage";
    const basse = op.application === "basse" && usage === "chauffage";
    const pacs = pacList(op);
    const pac = pacs.reduce((a, b) => a + b, 0);
    const chauf = n(op.puissanceChaufferie);
    const mini = basse ? 126 : 111;
    if (nb <= 0) issues.push("le nombre d'appartements chauffés doit être renseigné");
    if (etas < mini) issues.push(`l'Etas doit être au moins de ${mini} % (${basse ? "basse" : "moyenne / haute"} température)`);
    pacs.forEach((pu, i) => {
      if (pu <= 0) issues.push(`la puissance thermique nominale de la PAC ${i + 1} doit être renseignée`);
      else if (pu > 400) issues.push(`la PAC ${i + 1} dépasse 400 kW de puissance thermique nominale (fiche BAR-TH-179)`);
    });
    if (chauf && chauf < pac) issues.push("la puissance utile de la chaufferie doit inclure celle de l'ensemble des PAC");
    const r = ratioR(pac, chauf);
    const idx = ETAS_SEUILS.filter((s) => etas >= s).length - 1;
    const m = idx >= 0 ? T179[usage][zone][idx] : 0;
    const coef = op.cdp ? 3 : 1;
    if (op.cdp) issues.push(...cdpEnergieIssue(op));
    if (op.cdp && !op.cdpRaccordementImpossible)
      issues.push("Coup de pouce : l'impossibilité technique ou économique du raccordement à un réseau de chaleur doit être justifiée");
    return { kwh: m * nb * r * coef, logements: nb, detail: `${m.toLocaleString("fr-FR")} × ${nb} app. × R ${Math.round(r * 1000) / 1000}${op.cdp ? " × Coup de pouce 3" : ""}`, issues };
  }
  const typ = op.typeSysteme || "B";
  const nb = n(op.nbLogements);
  if (nb <= 0) issues.push("le nombre de logements ventilés doit être renseigné");
  const r = R127[typ][op.caisson || "basse_conso"];
  return { kwh: T127[zone] * nb * r, logements: nb, detail: `${T127[zone].toLocaleString("fr-FR")} × ${nb} logement(s) × R ${r}`, issues };
}

export function prixSelonVolume(totalKwhCumac, pricing = DEFAULT_PRICING) {
  const basePrec = parseFloat(pricing.prixPrecariteReel ?? DEFAULT_PRICING.prixPrecariteReel);
  const paliers = [...(pricing.paliers || [])].sort((a, b) => b.seuilKwhCumac - a.seuilKwhCumac);
  for (const p of paliers)
    if (totalKwhCumac > p.seuilKwhCumac) return { classique: p.prix, precarite: p.prixPrecarite ?? basePrec };
  return { classique: pricing.prixAutre ?? DEFAULT_PRICING.prixAutre, precarite: basePrec };
}

export function computeDossier(ops, { prixOverride = false, prixMwh = 0, prixCession, prixCessionPrecarite, departement } = {}, pricing = DEFAULT_PRICING) {
  const p = { ...DEFAULT_PRICING, ...pricing };
  const { min, max } = clientRange(p);
  const pr = precariteRange(p);
  const colonne = p.colonnePrecarite || "A";
  const pct = precaritePct(departement, colonne);
  const share = pct ?? 0;
  const vols = ops.map(volumeKwh);
  const totalKwh = vols.reduce((a, v) => a + v.kwh, 0);
  const auto = prixSelonVolume(totalKwh, p);
  const prixAuto = auto.classique;
  const prixReel = prixOverride ? parseFloat(prixMwh) || 0 : prixAuto;
  const prixReelPrec = parseFloat(auto.precarite) || 0;
  const cession = Math.min(max, Math.max(min, parseFloat(prixCession) || max));
  const cessionPrec = Math.min(pr.max, Math.max(pr.min, parseFloat(prixCessionPrecarite) || pr.max));
  const results = vols.map((v, i) => {
    const kp = v.kwh * share;
    const kc = v.kwh - kp;
    return {
      kwhCumac: v.kwh, kwhClassique: kc, kwhPrecarite: kp, mwhCumac: v.kwh / 1000,
      prime: (kc / 1000) * cession + (kp / 1000) * cessionPrec,
      logements: v.logements, detail: v.detail, dureeVie: FICHES[ops[i].fiche]?.dureeVie ?? null, issues: v.issues,
    };
  });
  const mwhPrec = (totalKwh * share) / 1000;
  const mwhClass = totalKwh / 1000 - mwhPrec;
  const primeClassique = mwhClass * cession;
  const primePrecarite = mwhPrec * cessionPrec;
  const primeCession = primeClassique + primePrecarite;
  const commissionTotal = Math.max(0, (max - cession) * mwhClass) + Math.max(0, (pr.max - cessionPrec) * mwhPrec);
  const primeBrute = mwhClass * prixReel + mwhPrec * prixReelPrec;
  const motifs = results.flatMap((r, i) => r.issues.map((m) => `Opération ${i + 1} : ${m}.`));
  if (ops.length && pct === null) motifs.push("Dossier : le département des travaux doit être renseigné pour répartir le volume classique / précarité.");
  return {
    results,
    totals: {
      nbOperations: ops.length,
      logementsTotal: results.reduce((a, r) => a + r.logements, 0),
      kwhCumacTotal: totalKwh,
      mwhCumacTotal: totalKwh / 1000,
      departement: departement || "",
      colonnePrecarite: colonne,
      pctPrecarite: share,
      mwhClassique: mwhClass,
      mwhPrecarite: mwhPrec,
      primeClassique,
      primePrecarite,
      prixCession: cession,
      prixClientMax: max,
      prixCessionPrecarite: cessionPrec,
      prixPrecariteMax: pr.max,
      prixApplique: prixReel,
      prixAuto,
      prixOverride: !!prixOverride,
      primeCessionTotal: primeCession,
      commissionTotal,
      primeBrute,
      margeInterne: primeBrute - primeCession - commissionTotal,
      primeNette: primeCession,
      eligible: motifs.length === 0,
      motifs,
    },
  };
}

/* Résumé court des paramètres d'une opération (listes, tiroir) */
export function opSummary(op) {
  const z = op.zone || "H1";
  if (op.fiche === "BAR-TH-137") return `${z} · ${fmt(op.nbLogements)} appartement(s)${op.cdp ? " · Coup de pouce" : ""}`;
  if (op.fiche === "BAR-TH-179")
    return `${z} · ${LABELS.usage[op.usage] || "Chauffage"} · Etas ${fmt(op.etas)} % · ${pacList(op).length} PAC = ${fmt(pacList(op).reduce((a, b) => a + b, 0), 1)} kW · ${fmt(op.nbLogements)} app.${op.cdp ? " · Coup de pouce ×3" : ""}`;
  if (op.fiche === "BAR-TH-127")
    return `${z} · type ${op.typeSysteme || "B"} · ${LABELS.caisson[op.caisson] || "Basse consommation"} · ${fmt(op.nbLogements)} logement(s)`;
  return z;
}

export function fmt(n, decimals = 0) {
  if (n === null || n === undefined || n === "" || Number.isNaN(Number(n))) return "—";
  return Number(n).toLocaleString("fr-FR", { minimumFractionDigits: decimals, maximumFractionDigits: decimals });
}

export function euros(n, decimals = 0) {
  return `${fmt(Math.round(n * 10 ** decimals) / 10 ** decimals, decimals)} €`;
}
